import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { StatementsFacade } from '@app/modules/businesses/services/statements.facade';
import { StatementType } from '@app/modules/businesses/models/statements.models';
import { UpsellService } from '@app/shared/+state/shared/upsell.service';
import { filter, map, tap } from 'rxjs/operators';
import { combineLatest } from 'rxjs';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-unpublish',
  templateUrl: './dialog-unpublish.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogUnpublishComponent implements OnInit {
  private accountingEnabled$ = this.upsellService.accountingEnabled$;
  private accountingConnectionEnabled$ = this.statementsFacade.connectionsState$.pipe(
    tap((state) => {
      if (!state.data?.length && !state.loading && !state.error) {
        this.statementsFacade.listConnections();
      }
    }),
    filter((state) => Boolean(state.data?.length)),
    map((state) => state.data?.find((connection) => connection.enabled))
  );

  public accountingConnected$ = combineLatest([this.accountingEnabled$, this.accountingConnectionEnabled$]).pipe(
    map(([accountingEnabled, accountingConnectionEnabled]) => accountingEnabled && accountingConnectionEnabled)
  );

  constructor(
    public dialogRef: MatDialogRef<DialogUnpublishComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { type: StatementType },
    private upsellService: UpsellService,
    private statementsFacade: StatementsFacade
  ) {}

  ngOnInit(): void {}
}
